import { z } from "zod";
import type { Operation } from "../../types";

const seedResultSchema = z.object({
  ok: z.literal(true),
  already_applied: z.boolean(),
  seed_version: z.number(),
  inserted: z.object({
    categories: z.number(),
    articles: z.number(),
    external_links: z.number(),
    product_categories: z.number(),
    product_articles: z.number(),
  }),
});

const apply: Operation<
  void,
  void,
  { version?: number; force?: boolean },
  z.infer<typeof seedResultSchema>
> = {
  method: "POST",
  path: () => "/api/help/seed/apply",
  body: z
    .object({
      version: z.number().int().min(1).optional(),
      force: z.boolean().optional(),
    })
    .partial(),
  response: seedResultSchema,
};

export const seed = { apply };
